const NotificationSiteMetaLine = ({
  wasteName,
  addressName,
  className = "notification-site-meta",
}) => {
  if (!wasteName && !addressName) {
    return null;
  }

  return (
    <p className={className}>
      {wasteName && (
        <span className="notification-site-meta-waste">{wasteName}</span>
      )}
      {wasteName && addressName && (
        <span className="notification-site-meta-separator"> · </span>
      )}
      {addressName && (
        <span className="notification-site-meta-address" title={addressName}>
          {addressName}
        </span>
      )}
    </p>
  );
};

export default NotificationSiteMetaLine;
